/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';

class DateDisplay extends React.Component {
    constructor(props) {
        super(props);

        let dateTime = moment();

        // !!! Setting a param on a global alert
        moment.relativeTimeRounding(Math.floor);

        if (this.props.useTimezone) {
            dateTime = moment().tz(this.props.user.detail.timezone);
        }

        this.state = {
            dateTime
        };

        this.prepareDateTime = this.prepareDateTime.bind(this);
        this.getMoment = this.getMoment.bind(this);
        this.formatMoment = this.formatMoment.bind(this);
    }

    componentDidMount() {

        this.prepareDateTime(this.props);

    }

    componentDidUpdate(prevProps, prevState) {

        if (!_.isEqual(prevProps.dateTime, this.props.dateTime)) {
            this.prepareDateTime(this.props);
        }

    }

    prepareDateTime(props) {
        let dateTime = props.dateTime
            ? this.getMoment(props)
            : this.state.dateTime;

        this.setState({
            dateTime
        });

    }

    getMoment(props) {
        let ret = null,
            dateTime = props.dateTime,
            timezone = this.props.user.detail.timezone,
            _dateTime = null;

        if (moment.isMoment(dateTime)) {
            ret = dateTime;
        } else if (moment.isDate(dateTime)) {
            ret = moment(dateTime.toISOString());
            if (this.props.useTimezone) {
                ret.tz(timezone);
            }
        } else if (typeof dateTime === "string" || typeof dateTime === "number") {
            try {
                _dateTime = moment(dateTime);
                if (moment.isMoment(_dateTime)) {
                    ret = _dateTime;
                    if (this.props.useTimezone) {
                        ret.tz(timezone);
                    }
                } else {
                    throw(_dateTime);
                }
            } catch (d) {
                _dateTime = moment(new Date(dateTime).toISOString());
                if (moment.isMoment(_dateTime)) {
                    ret = _dateTime;
                    if (this.props.useTimezone) {
                        ret.tz(timezone);
                    }
                }
            } finally {
                if (!ret) {
                    ret = moment();
                    if (this.props.useTimezone) {
                        ret.tz(timezone);
                    }
                }
            }
        }

        return ret;

    }

    formatMoment() {

        let daysAgo = + this.props.daysAgo;
        let timezone = this.props.user.detail.timezone;
        let dateTime = this.state.dateTime;
        let dateTimeFormat = this.props.dateTimeFormat;
        let withRelative = this.props.withRelative;
        let formattedTime,
            relative = '';
        let now = moment();
        if (timezone) {
            now.tz(timezone);
        }

        if (dateTime === undefined) {
            return formattedTime;
        }

        switch (dateTimeFormat) {
            case 'human':
                if (dateTime.diff(now, 'days') < daysAgo) {
                    formattedTime = dateTime.fromNow();
                } else {
                    formattedTime = dateTime.format('MMM Do, Y');
                }
                break;

            case 'relative':
                formattedTime = dateTime.fromNow();
                break;

            case 'long':
                formattedTime = dateTime.format('MMM D, YYYY, h:mm A');
                break;

            default:
                formattedTime = dateTime.format(dateTimeFormat);
                break;
        }

        if (withRelative) {
            let age = Math.abs(dateTime.diff(now, 'seconds'));

            let weeks = Math.floor(age / (86400 * 7));
            age %= (86400 * 7);

            let days = Math.floor(age / 86400);
            age %= 86400;

            let hours = Math.floor(age / 3600);
            age %= 3600;

            let minutes = Math.floor(age / 60);
            age %= 60;

            let seconds = age;

            if (weeks)
                relative += weeks + ' week' + (
                    weeks > 1
                    ? 's'
                    : '') + ' ';
            if (days)
                relative += days + ' day' + (
                    days > 1
                    ? 's'
                    : '') + ' ';
            if (hours)
                relative += hours + ' hour' + (
                    hours > 1
                    ? 's'
                    : '') + ' ';
            if (minutes)
                relative += minutes + ' minute' + (
                    minutes > 1
                    ? 's'
                    : '') + ' ';

            // Only display seconds if there is no higher value
            if (!(weeks || days || hours || seconds) && seconds) {
                relative += seconds + ' second' + (
                    seconds > 1
                    ? 's'
                    : '');
            }

            if (relative) {
                relative += 'ago';
            }
        }

        return [formattedTime, relative];

    }

    render() {

        let formattedDates = this.formatMoment();

        if (this.props.withRelative) {
            return <span title={formattedDates[1]}>{formattedDates[0]}</span>
        }

        return <span>{formattedDates[0]}</span>;

    }

};

DateDisplay.propTypes = {
    dateTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    dateTimeFormat: PropTypes.string,
    user: PropTypes.object,
    timezone: PropTypes.string,
    daysAgo: PropTypes.number,
    daysFromNow: PropTypes.number,
    useTimezone: PropTypes.bool,
    relativeThreshholds: PropTypes.object
};

DateDisplay.defaultProps = {
    dateTime: null,
    dateTimeFormat: 'human',
    daysAgo: 2,
    daysFromNow: 2,
    useTimezone: true,
    user: {},
    relativeThreshholds: {}
};

export default DateDisplay;
